import { observer } from 'mobx-react-lite';

import { CloseIcon, CopyIcon, IcDelete32Icon } from '@gem/icons';
import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { useTranslation } from '@gem/modules/i18n';
import { Button, IconButton, IconViewSizes } from '@gem/ui-kit';

import { useMultiSelectPresenter } from './MultiSelectPanel.presenter';
import styles from './MultiSelectPanel.styles.m.scss';

export const MultiSelectPanel = observer(() => {
  const presenter = useMultiSelectPresenter();
  const { t } = useTranslation();

  const header = t('multiselect_menu_with_options_web', { 0: presenter.amountOfMessages });

  return (
    <>
      <AddKeyPressHandler onEsc={presenter.close} />
      <div className={styles.container}>
        <div className={styles.messageCount}>
          <IconButton
            Icon={CloseIcon}
            onClick={presenter.close}
          />
          <span className={styles.counter}>{header}</span>
        </div>
        {presenter.hasSelectedMessages && (
          <div className={styles.actionContainer}>
            {presenter.canBeDeleted && (
              <IconButton
                Icon={IcDelete32Icon}
                size={IconViewSizes.Big}
                onClick={presenter.delete}
              />
            )}
            {presenter.canBeCopied && (
              <IconButton
                Icon={CopyIcon}
                className={styles.indent}
                onClick={presenter.copyToClipboard}
              />
            )}
            {presenter.canBeForwarded && (
              <Button
                className={styles.indent}
                theme="text-secondary"
                onClick={presenter.forward}
              >
                {t('message_forward')}
              </Button>
            )}
            {presenter.canBeSendNow && (
              <Button
                className={styles.indent}
                theme="text-secondary"
                onClick={presenter.sendNow}
              >
                {t('common_send_now')}
              </Button>
            )}
          </div>
        )}
      </div>
    </>
  );
});
